<template>
  <div is="panel" id="travel-distance">
    <div class="panel-travel-distance">
      <h2 class="page-header">Hoe ver wil je maximaal reizen naar je coach?</h2>
      <div class="panel-text-container">
        <p>Sleep het bolletje naar de gewenste maximale afstand.</p>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="distance-wrapper">
            <div class="distance-label">Vul je maximale afstand in:</div>
            <div class="distance-value blue">{{ answer.distance }} KM</div>
          </div>
          <input name="distance" type="range" min="20" max="50" step="5" v-model="answer.distance">
        </div>
      </div>
      <div v-if="$parent.loading" class="loading-container">
        <div class="loading-text">We zijn gegevens aan het ophalen.<br>Een ogenblik geduld...</div>
      </div>
      <div class="buttons-container">
        <previous-button />
        <button @click="submitAnswer">Toon mijn matches</button>
      </div>
    </div>
  </div>
</template>

<script>
import NextButton from "../partials/NextButton";
import PreviousButton from "../partials/PreviousButton";

export default {
  name: 'TravelDistance',
  components: {
    PreviousButton,
    NextButton
  },
  props: {
    isValid: {
      type: Function
    },
    answer: {
      type: Object
    },
    invalid: {
      type: Object
    },
    isAnswered: {
      type: Object
    },
    submitAnswer: {
      type: Function
    }
  }
}

</script>